import { createIcon } from './createIcon'

export const OceanShipmentsIcon = createIcon({
  displayName: 'Ocean',
  viewBox: '0 0 25 21',
  path: [
    <path
      fill="currentColor"
      d="M11.402 14.027a1.051 1.051 0 011.434 0 7.942 7.942 0 006.292 2.62c.273-.038.542-.097.805-.177a.329.329 0 00.232-.232l1.092-3.781a.684.684 0 00-.349-.79.67.67 0 00-.306-.07H4.742a1.364 1.364 0 00-1.133.6 1.365 1.365 0 00-.11 1.297s0-.164 1.365 2.921a.287.287 0 00.219.178l.286.068a7.616 7.616 0 006.033-2.635zM21.202 4.472a1.05 1.05 0 00-.914-1.147h-.382a.341.341 0 01-.341-.34V1.51a1.01 1.01 0 10-2.02 0v1.46a.341.341 0 01-.342.342h-2.498a1.051 1.051 0 00-.928 1.146v5.269a.34.34 0 00.341.341h6.702a.341.341 0 00.341-.341l.041-5.255z"
    />,
    <path
      fill="currentColor"
      d="M5.15 20.483c.255.014.51.014.765 0a9.39 9.39 0 005.979-2.362.328.328 0 01.436 0 9.403 9.403 0 007.016 2.348 6.485 6.485 0 004.736-2.976 1.014 1.014 0 10-1.72-1.078 4.395 4.395 0 01-3.275 2.034 7.944 7.944 0 01-6.293-2.62 1.037 1.037 0 00-1.364 0 7.587 7.587 0 01-6.033 2.62 4.71 4.71 0 01-3.536-2.157 1.01 1.01 0 00-1.842.737 6.442 6.442 0 005.132 3.454zM7.294 6.014a.955.955 0 00-.901 1.01v2.73a.341.341 0 00.341.341h4.723a.341.341 0 00.34-.34v-3.4a.341.341 0 00-.34-.34H7.294z"
    />,
  ],
})
